module.exports = __webpack_public_path__ + "img/Image_1__Second_Canal_996_10_2_entrance_to_Welland_Canal___Port_Colborne.b1113848.jpg";